import React from 'react'
import './Loader.css'
export const SpinnerLoader = () => {
    return (
        <div className="spinner">
            <div className="loading">
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
            </div>
        </div>
    )
}
